require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./statistiques-dtailles-2-0-4-2.json") })
        }
      }, "path---statistiques-dtailles-2-0-4-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---statistiques-dtailles-2-0-4-2!./.cache/json/statistiques-dtailles-2-0-4-2.json
// module id = 576
// module chunks = 231608221292675